export const PENDING = 'PENDING'
export const ALLOWED = 'ALLOWED'
export const DENIED = 'DENIED'

export const statuses = [PENDING, ALLOWED, DENIED]